/** Original Grand & Kansas North palette — Pacific Indigo · California Terracotta · Warm Parchment */
export const FOREST_GREEN = "#2A4275";
export const DARK_GREEN = "#182D4E";
export const GOLD = "#C05A36";
export const CREAM = "#F3EBE0";
export const MAROON = "#7A3020";

/** Text on terracotta (#C05A36) CTA buttons */
export const GOLD_CTA_TEXT = "#ffffff";

export const FOOTER_EMAIL_FALLBACK = "info@grandkansasnorth.com";
export const FOOTER_PHONE_FALLBACK = "(424) 404-9538";

export function footerTelHref(phone: string): string {
  const d = phone.replace(/\D/g, "");
  if (d.length === 10) return `tel:+1${d}`;
  if (d.length === 11 && d[0] === "1") return `tel:+${d}`;
  return d ? `tel:${d}` : "tel:";
}
